import styled from "styled-components";

const StyledTBody = styled.tbody``;

export const TableBody = (props: any) => {
  const { children } = props;

  return <StyledTBody>{children}</StyledTBody>;
};
